module.exports = "https://coursera_assets.s3.amazonaws.com/images/567e7c69f52c00ee6d1d51faa5123699.png";